import PropTypes from "prop-types";

export const GeneralReportOrganizationBillingComponent = ({ athletes }) => {
  return (
    <section role="table-wrapper" data-borders-inside data-scrollable>
      <table role="report-table">
        <thead className="labels">
          <tr>
            <th className="name">Athlete</th>
            <th className="email">Email</th>
            <th className="name">Assigned coach</th>
            <th className="amount">Total days</th>
          </tr>
        </thead>
        <tbody>
          {athletes.length > 0 &&
            athletes.map((athlete) => {
              const {
                athleteName = "",
                athleteEmail = "",
                amount: athleteAmount,
                athleteId,
                coachName = "",
              } = athlete;
              return (
                <tr className="report" key={String(athleteId)}>
                  <td className="name">{athleteName}</td>
                  <td className="email">{athleteEmail}</td>
                  <td className="name">{coachName}</td>
                  <td className="amount">{Number(athleteAmount).toFixed(0)}</td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </section>
  );
};

GeneralReportOrganizationBillingComponent.contextTypes = {
  athletes: PropTypes.array,
};
